export const depositMapping = {
  A_0: 0,
  A_1: 1,
};
